import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Card, CardContent, Stack } from "@mui/material";
import { WizardSchemaType } from "./index.tsx";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles/createTheme";
import AccordionWizard from "./accordions/accordion-wizard.tsx";
import { AgendaResource } from "./resources/agendas/index.tsx";
import { DocResource } from "./resources/docs/index.tsx";
import { WhyChooseResource } from "./resources/why-chooses/index.tsx";
import { ObjectResource } from "./resources/objects/index.tsx";
import { FAQResource } from "./resources/faqs/index.tsx";
import { ResourceKey } from "./step-resource.tsx";
import CardWizard from "./card-wizard.tsx";

interface PropTypes {
	methods: UseFormReturn<WizardSchemaType>;

	onToggle: (key: ResourceKey) => void;
	onExpandSection: (key: ResourceKey) => void;

	showAgendas: boolean;
	showDocs: boolean;
	showWhy: boolean;
	showObject: boolean;
	showQAs: boolean;

	expandAgendasSection: boolean;
	expandDocsSection: boolean;
	expandWhySection: boolean;
	expandObjectSection: boolean;
	expandQAsSection: boolean;
}

const StepResourceDesktop: React.FC<PropTypes> = ({
	methods,
	onToggle,
	onExpandSection,
	showAgendas,
	showWhy,
	showObject,
	showQAs,
	showDocs,
	expandAgendasSection,
	expandDocsSection,
	expandWhySection,
	expandObjectSection,
	expandQAsSection,
}) => {
	return (
		<>
			{showAgendas && (
				<CardWizard>
					<CardContent sx={{ p: "0 !important" }}>
						<AccordionWizard
							onDelete={() => {
								onToggle(ResourceKey.AGENDAS);
							}}
							onToggle={() => onExpandSection(ResourceKey.AGENDAS)}
							expanded={expandAgendasSection}
							accordionSummary={<AgendaResource.Header />}
						>
							<AgendaResource.Content methods={methods} />
						</AccordionWizard>
					</CardContent>
				</CardWizard>
			)}
			{showDocs && (
				<CardWizard>
					<CardContent sx={{ p: "0 !important" }}>
						<AccordionWizard
							onDelete={() => {
								onToggle(ResourceKey.DOCS);
							}}
							onToggle={() => onExpandSection(ResourceKey.DOCS)}
							expanded={expandDocsSection}
							accordionSummary={<DocResource.Header />}
						>
							<DocResource.Content methods={methods} />
						</AccordionWizard>
					</CardContent>
				</CardWizard>
			)}
			{showWhy && (
				<CardWizard>
					<CardContent sx={{ p: "0 !important" }}>
						<AccordionWizard
							onDelete={() => {
								onToggle(ResourceKey.WHY);
							}}
							onToggle={() => onExpandSection(ResourceKey.WHY)}
							expanded={expandWhySection}
							accordionSummary={<WhyChooseResource.Header />}
						>
							<WhyChooseResource.Content />
						</AccordionWizard>
					</CardContent>
				</CardWizard>
			)}
			{showObject && (
				<CardWizard>
					<CardContent sx={{ p: "0 !important" }}>
						<AccordionWizard
							onDelete={() => {
								onToggle(ResourceKey.OBJECT);
							}}
							onToggle={() => onExpandSection(ResourceKey.OBJECT)}
							expanded={expandObjectSection}
							accordionSummary={<ObjectResource.Header />}
						>
							<ObjectResource.Content />
						</AccordionWizard>
					</CardContent>
				</CardWizard>
			)}
			{showQAs && (
				<CardWizard>
					<CardContent sx={{ p: "0 !important" }}>
						<AccordionWizard
							onDelete={() => {
								onToggle(ResourceKey.QAS);
							}}
							onToggle={() => onExpandSection(ResourceKey.QAS)}
							expanded={expandQAsSection}
							accordionSummary={<FAQResource.Header />}
						>
							<FAQResource.Content methods={methods} />
						</AccordionWizard>
					</CardContent>
				</CardWizard>
			)}
		</>
	);
};

export default StepResourceDesktop;
